import config from "../../app.json";
import axios from "axios";

import { Context } from "../../Reducers/Store";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import "./Styles/home.scss";

import Greetings from "../../Components/Greetings/greetings";
import EventCard from "../../Components/EventCard/event-card";
import VolunteerCard from "../../Components/VolunteerCard/volunteer-card";
import DashboardPlanInfo from "../../Components/DashboardPlanInfo";
import Eventlog from "../../Components/Eventlog";
import FieldUploadMultipart from "../../Components/Fields/FieldUploadMultipart";

function Home() {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [cards, setCards] = useState([]);
  const [seats, setSeats] = useState(null);
  const [volunteers, setVolunteers] = useState([]);
  const [eventLog, setEventLog] = useState([]);
  const [activeEvents, setActiveEvents] = useState([]);

  const fetchUpcomingEvents = () => {
    axios
      .post(config.API + "/api/event/getUpcomingEvents")
      .then((res) => {
        if (res.status === 200 && res.data) {
          res.data.$values.map(i => {
            if (!window._channelsIds.includes(i.channelId))
              window._channelsIds.push(i.channelId);
          });
          setCards(res.data.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchActiveEvents = () => {
    axios
      .post(config.API + "/api/channel/getRunningChannels", { take: 3 })
      .then((res) => {
        if (res.status === 200 && res.data) {
          res.data.$values.map(i => {
            if (!window._channelsIds.includes(i.id))
              window._channelsIds.push(i.id);
          });
          setActiveEvents(res.data.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchSeats = () => {
    axios
      .post(config.API + "/api/church/getSeats")
      .then((res) => {
        if (res.status === 200 && res.data) {
          setSeats(res.data);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchUsers = () => {
    axios
      .post(config.API + "/api/user/getUsers", {
        page: 0,
        perPage: 6,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setVolunteers(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchEventsLog = () => {
    axios
      .post(config.API + "/api/history/getHistories", {
        page: 0,
        perPage: 5,
        tokens: ["TOKEN_HISTORY_EVENT_STARTED", "TOKEN_HISTORY_EVENT_STOPPED"],
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setEventLog(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    if (state.profile.role == "ROLE_CHURCH_MEDIA_MANAGER") {
      navigate("/videoArchive", { replace: false });
    }
    else {
      if (state.profile.role == "ROLE_CHURCH_ADMIN" || state.profile.role == "ROLE_CHURCH_PRODUCER") {
        fetchActiveEvents();
        fetchUpcomingEvents();
      }
      if (state.profile.role == "ROLE_CHURCH_ADMIN") {
        fetchSeats();
        fetchEventsLog();
        fetchUsers();
      }
    }
  }, [0]);

  return (
    <Row className="gx-5 pt-4">
      <Col className="col-md-8">
        <Greetings />
        {(state.profile.role == "ROLE_CHURCH_ADMIN" || state.profile.role == "ROLE_CHURCH_PRODUCER") &&
          <>
            {cards && cards.length > 0 && <Row className="event-card-container">
              <div className="header-section-dash">
                <h3 className="section-title-dash">Upcoming Events</h3>
                <a href="/listingEvents" className="view-all-link">View All</a>
              </div>
              {(cards == null || cards.length == 0) && <div>Nothing here...</div>}
              {cards.map((x, index) => (
                <Col className="col-md-4" key={"event_upcoming_" + index + "_" + x.id}>
                  <EventCard
                    id={x.id}
                    name={x.name}
                    place={x.channelName}
                    startTime={x.startTime}
                    channelId={x.channelId}
                    startDate={x.nextStart}
                    autoStart={x.autoStart}
                    fetchChannelData={false}
                  />
                </Col>
              ))}
            </Row>}
            {(cards == null || cards.length == 0) && <div className="empty-state mb-5"><h3 className="section-title-dash">Upcoming Events</h3><div className="empty-state-card">{state.profile.role == "ROLE_CHURCH_ADMIN" ? "Create your first event!" : "No events found."}</div></div>}
            {activeEvents && activeEvents.length > 0 && <Row className="event-card-container">
              <div className="header-section-dash">
                <h3 className="section-title-dash">Active Events</h3>
                {activeEvents && activeEvents.length > 0 && <a href="/listingEvents" className="view-all-link">View All</a>}
              </div>
              {activeEvents.map((x, index) => (
                <Col className="col-md-4" key={"event_active_" + index + "_" + x.id}>
                  <EventCard
                    id={x.eventId}
                    name={x.eventName}
                    place={x.name}
                    startTime={x.startTime}
                    channelId={x.id}
                    startDate={x.nextStart}
                    autoStart={x.autoStart}
                    fetchChannelData={true}
                    isView={true}
                  />
                </Col>
              ))}
            </Row>}
            {(activeEvents == null || activeEvents.length == 0) && <div className="empty-state"><h3 className="section-title-dash">Active Events</h3><div className="empty-state-card">No active events at this moment ...</div></div>}
          </>
        }

        {state.profile.role == "ROLE_CHURCH_ADMIN" && <>
          <Row>
            <Col className="col-md-12">
              <div className="header-section-dash mb-0 mt-4">
                <h3 className="section-title-dash">Team</h3>
                <a href="/users" className="view-all-link">View All</a>
              </div>
            </Col>
          </Row>
          <Row className="volunteer-card-container">
            {volunteers.map((x) => (
              <Col className="mb-4 md-col-4" key={"volunteer_" + x.id}>
                <VolunteerCard {...x} />
              </Col>
            ))}
          </Row>
        </>
        }
      </Col>
      {state.profile.role == "ROLE_CHURCH_ADMIN" &&
        <Col className="col-md-3">
          <Row className="mb-4 ">
            <DashboardPlanInfo {...seats} />
          </Row>

          <Row>
            <Eventlog eventLog={eventLog} />
          </Row>
        </Col>}
    </Row>
  );
}

export default Home;
